import {firebase} from '../config/fbconfig';
const csv = require('csvtojson')
const db = firebase.firestore();
var metadata = {
    contentType: 'file/xlxs'
};
class Shows{
     static async addShow(showsData){
        //  let excelFile = document.querySelector('input[id=SeatSection]').files[0];
        //  csv()
        //  .fromFile(excelFile)
        //  .then((jsonObj) => {
        //     console.log(jsonObj)
        //  })
      return new Promise((resolve, reject) => {
        db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('shows').add(showsData).then(ref => {
                ref.set({
                    id: ref.id
                }, {
                    merge: true
                }).then(async() => {
                    const snapshot = await  db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('shows').get()
                    return resolve(snapshot.docs.map(doc => doc.data()));
                }, (err) => {
                    return reject(err);
                })
            });
        });
    }

    static async getShows() { 
        const snapshot = await  db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('shows').get()
        return snapshot.docs.map(doc => doc.data());
    }
  
    static DeleteShow(DataId) {
        return new Promise((resolve, reject) => {
            db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('shows').doc(DataId).delete().then(async() => {
                const snapshot = await  db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('shows').get()
                return resolve(snapshot.docs.map(doc => doc.data()));
            }, (err) => {
                return reject(err);
            });
        })

    }
}
export default Shows
